<template>
  <div>
    <div
      v-if="sessionCount > 0"
      :class="['course-session-tiles', { 'course-session-tabs': numberOfMonths > 1 }]"
      data-ui="available-sessions"
    >
      <div
        class="course-session-tiles__heading"
        data-ui="available-sessions-heading"
      >
        <cdr-text
          class="course-session-tiles__heading-text"
          tag="h2"
        >
          Schedule
        </cdr-text>
        <location-search-facet
          v-if="!location.props.location"
          v-bind="location.props"
          v-on="location.on"
        />
      </div>
      <cdr-accordion
        v-for="{
          sessions,
          showMoreBtnToggle,
          moreShown,
          month,
          waitlistOnly,
          expanded,
          on,
        } in sessionsByMonth"
        :id="month"
        :key="month"
        :opened="expanded"
        level="3"
        class="course-session-tiles__month"
        data-ui="course-session-tabs"
        v-on="on"
      >
        <template #label>
          <span class="course-session-tiles__month-title">
            {{ month }}
          </span>
          <span
            v-if="waitlistOnly"
            class="course-session-tiles__month--note"
          >
            Waitlist only
          </span>
        </template>
        <sessions-rail
          :sessions="sessions"
          :show-more-btn-toggle="showMoreBtnToggle"
          :more-shown="moreShown"
        />
      </cdr-accordion>
      <location-search-facet
        v-if="location.props.location"
        v-bind="location.props"
        v-on="location.on"
      />
    </div>
    <template v-else>
      <cdr-text
        class="course-session-tiles__heading-text"
        tag="h2"
      >
        Schedule
      </cdr-text>
      <cdr-text
        class="course-sessions__no-sessions"
        data-ui="no-available-sessions"
      >
        <!-- eslint-disable vue/multiline-html-element-content-newline vue/singleline-html-element-content-newline -->
        {{ noSessions.text }}
        <!--
       -->
        <cdr-link
          v-if="noSessions.link"
          v-bind="noSessions.link.attr"
          class="course-sessions__no-sessions-link"
          v-on="noSessions.link.on"
        >
          <!--
       -->
          {{ noSessions.link.label }}
          <!--
       -->
        </cdr-link>
        <!--
       -->
        <template v-if="noSessions.link">.</template>
        <!-- eslint-disable vue/multiline-html-element-content-newline vue/singleline-html-element-content-newline -->
      </cdr-text>
      <location-search-facet
        v-bind="location.props"
        v-on="location.on"
      />
    </template>
  </div>
</template>

<script>
import { CdrAccordion, CdrLink, CdrText } from '@rei/cedar';
import SessionsRail from './SessionsRailComponent.vue';
import LocationSearchFacet from './LocationSearchFacet.vue';

export default {
  name: 'FilterByMonthComponent',
  components: {
    CdrAccordion,
    CdrLink,
    CdrText,
    SessionsRail,
    LocationSearchFacet,
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
    noSessions: {
      type: Object,
      required: true,
    },
    sessionsByMonth: {
      type: Array,
      required: true,
    },
    sessionCount: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    noSessionsAvailableText:
      'Looks like no sessions are scheduled right now. Please bookmark this page and check back soon.',
  }),
  computed: {
    sessionsAvailableText() {
      const { noSessionsAvailableText, sessionCount } = this;
      let sessionsAvailableText = noSessionsAvailableText;
      if (sessionCount !== 0) {
        sessionsAvailableText = 'Schedule';
      }
      return sessionsAvailableText;
    },
    numberOfMonths() {
      return this.sessionsByMonth.length;
    },
  },
  methods: {
    showMoreResults() {
      const moreResults = document.querySelector('.course-session-tiles__show-more');
      const hiddenTiles = document.querySelectorAll('.opo-card--hidden');
      if (hiddenTiles.length) {
        for (let i = 0; i < hiddenTiles.length; i += 1) {
          hiddenTiles[i].classList.remove('opo-card--hidden');
        }
        moreResults.classList.add('cdr-display-none');
      }
    },
  },
};
</script>
